export default [
  {
    path: "/tax-adjustment",
    component: () => import("../layout/PageLayoutWithoutContainer.vue"),
    beforeEnter: (to, from, next) => {
      if (process.env.VUE_APP_ENABLE_TAX_ADJUSTMENT === 'true') {
        next();
      }
      else {
        next({ path: '/page-not-found' });
      }
    },
    children: [
      {
        path: ":id",
        name: "Tax Adjustment",
        component: () => import("@/views/TaxAdjustment/TaxAdjustment.vue")
      },
      {
        path: "confirmation/:orderId",
        name: "Tax Adjustment Confirmation",
        props: true,
        component: () => import("@/views/TaxAdjustment/TaxAdjustment.vue"),
        meta: { confirmation: true, failure: false }
      },
      {
        path: "failure/:orderId",
        name: "Tax Adjustment Failure",
        component: () => import("@/views/TaxAdjustment/TaxAdjustment.vue"),
        props: true,
        meta: { confirmation: false, failure: true }
      }
    ]
  }
];
